<template>
    <div class="app">
      <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
      <v-sheet v-show="showSkeleton" class="pa-3">
        <v-row>
          <v-col>
            <v-skeleton-loader class="mx-auto" type="image" height="220" />
          </v-col>
        </v-row>
      </v-sheet>
        <v-dialog 
            v-show="!showSkeleton"
            v-model="dialog"
            persistent
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-show="!showSkeleton"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                Segware
                </v-btn>
            </template>
            <v-card ref="form" >
                <v-card-title>
                    <span class="text-h5">Configuração Segware</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                            dense
                            v-model="form.ramais"
                            :items="ramais"
                            label="Ramal"
                            outlined
                            :error-messages="ramaisErrors"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col>
                            <v-text-field
                                dense
                                v-model.number="form.timeout"
                                label="Timeout"
                                type="number"
                                outlined
                                :error-messages="timeoutErrors"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                dense
                                v-model="form.audioSenha"
                                :items="audios"
                                label="Áudio senha"
                                outlined
                                :error-messages="audioSenhaErrors"
                            />
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                dense
                                v-model="form.audioHorario"
                                :items="audios"
                                label="Áudio de Horário"
                                outlined
                                :error-messages="audioHorarioErrors"
                            />
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                dense
                                v-model="form.audioAgradecimento"
                                :items="audios"
                                label="Áudio de Agradecimento"
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                dense
                                label="URL"
                                v-model="form.url"
                                outlined
                                :error-messages="urlErrors"
                            />
                        </v-col>
                        <v-col>
                            <v-text-field
                                dense
                                label="Token"
                                v-model="form.token"
                                outlined
                                :error-messages="tokenErrors"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="cancelar()"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="salvar()"
                    >
                        Salvar
                    </v-btn>
                </v-card-actions>
            <!-- <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" /> -->
            </v-card>
        </v-dialog>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapActions} from 'vuex'
//   import FixedButtons from '@/componentes/FixedButtons'
  
  import Snackbar from '@/componentes/Snackbar'
  import { registerVuexModule } from '@/utils/vuexUtils'
  
  import IntegracoesStore from '../_store'
  import { validateData, validateComputed } from '../_validates'
  import IntegracoesHttpServices from '../_services/IntegracoesHttpService'
  
  export default {
    name: 'AbaSigma',
    props: {
      _id: String,
    },
    components: { Snackbar },
  
    data: () => ({
        form: {
            ramais:[],
            troncos:'',
            audioHorario:'',
            audioSenha:'',
            url:'',
            token:'',
            tipo:'segware',
            timeout: '',
            // audioErro:'',
            audioAgradecimento:'',
        },
        ramais:[],
        tags:[],
        troncos:[],
        audios: [],

        dialog: false,

        pararLoader: {
            parar: false,
        },
        showSkeleton: true,
        text: '',
        snackbar: false,
    }),
    
    validations: {
        ...validateData,
    },
  
  
    computed: {
        ...validateComputed,
        ...mapGetters('AbaSigmaModulePABXStore', ['getagendamentoSelecionado','getRamais','getTroncos','getTags', 'getIntegracaoSegware', 'getAudios']),
        todosRamaisSelecionados() {
            return this.form.ramais.length === this.ramais.length
        },
        algunsRamaisSelecionados() {
            return this.form.ramais.length > 0 && !this.todosramaisSelecionados
        },
        iconRamais() {
            if (this.todosRamaisSelecionados) return 'mdi-close-box'
            if (this.algunsRamaisSelecionados) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        todosTroncosSelecionados() {
            return this.form.troncos.length === this.troncos.length
        },
        algunsTroncosSelecionados() {
            return this.form.troncos.length > 0 && !this.todosTroncosSelecionados
        },
        iconTroncos() {
            if (this.todosTroncosSelecionados) return 'mdi-close-box'
            if (this.algunsTroncosSelecionados) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        todosTagsSelecionados() {
            return this.form.tags.length === this.tags.length
        },
        algunsTagsSelecionados() {
            return this.form.tags.length > 0 && !this.todosTagsSelecionados
        },
        iconTags() {
            if (this.todosTagsSelecionados) return 'mdi-close-box'
            if (this.algunsTagsSelecionados) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
    },
  
    async created() {
        registerVuexModule(this.$store, 'AbaSigmaModulePABXStore', IntegracoesStore)

        await this.listarRamais() 
        await this.listarTroncos()
        await this.listarTags()
        await this.listaIntegracaoSegware()
        await this.listarAudios()

        this.ramais = this.getRamais.map(ramal => ({ text: ramal.numero, value: ramal._id }))
        this.tags = this.getTags.map(ramal => ({ text: ramal.description, value: ramal._id }))
        this.troncos = this.getTroncos.map(tronco => ({ text: tronco.description, value: tronco._id }))
        this.audios = this.getAudios.map(audios => ({ text: audios.description, value: audios._id }))
        
        if (this.getIntegracaoSegware) {
            this.form = {...this.getIntegracaoSegware}
        }else if(this.getIntegracaoSegware.url === undefined){
            this.form.url = 'https://cloud.segware.com.br/server/api/v1/uraResponse';
        }
        this.showSkeleton = false
    },
  
    methods: {
        ...mapActions('AbaSigmaModulePABXStore', ['listarRamais','listarTroncos','listarTags', 'listaIntegracaoSegware', 'listarAudios']),
        toggleRamais() {
            this.$nextTick(() => {
                if (this.todosRamaisSelecionados) {
                    this.form.ramais.splice(0)
                } else {
                    this.form.ramais.splice(0)
                    this.form.ramais = this.ramais.map(ramal => ramal.value)
                }
            })
        },
        toggleTroncos() {
            this.$nextTick(() => {
                if (this.todosTroncosSelecionados) {
                this.form.troncos.splice(0)
                } else {
                this.form.troncos.splice(0)
                this.form.troncos = this.troncos.map(troncos => troncos.value)
                }
            })
        },
        toggleTags() {
            this.$nextTick(() => {
                if (this.todosTagsSelecionados) {
                this.form.tags.splice(0)
                } else {
                this.form.tags.splice(0)
                this.form.tags = this.tags.map(tags => tags.value)
                }
            })
        },

        async salvar() {
            this.pararLoader.parar = false
            this.$v.$touch()
            if (this.$v.$error) {
                this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
                this.pararLoader.parar = true
                return
            }
            try {
                await IntegracoesHttpServices.postintegracaosegware(this.form);
            } catch (error) {
                let key = Object.keys(error.response.data)
                this.text = error.response.data[key[0]]
                this.pararLoader.parar = true
                this.snackbar = true
            }
            this.dialog = false
           
        },
        cancelar() {
            this.$v.$reset();
            this.dialog = false
        },
    },
  }
  </script>
  
  <style scoped>
  .app {
    background-color: var(--v-background-base);
  }
  </style>
  